import React from 'react'

import { createContext, useState } from "react";
import axios from "axios"
import AuthContext from "./AuthContext";
import StatusContext from "./StatusContext";
import ClientContext from "./ClientContext";

import { config } from '../config';
import { sortChats } from './StatusContext';

const TranslationContext = createContext();

export default TranslationContext;

export const TranslationProvider = ((props) => {
    const [prompt, setPrompt] = useState('');
    const [language, setLanguage] = useState('English');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [confirmDelete, setConfirmDelete] = useState([])
    const [status, setStatus] = useState()
    const [showTranslationLanguages,  setShowTranslationLanguages] = useState(false)
    
    const {
        currentUser,
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        ScrollResponse,
        setIsLoading,
        isLoading,
        changeLanguage,
        getChats,
        setShowLoginDialog,
        handleFocus,
        setWaitOnResponse,
        getAIProvider,
        getAIModel,
        getAIName,
       
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);    

  
    const displaySample = (sample) => {
        console.log("Sample:", sample)
        if (sample === "..." || sample === "No Sample")
        {
            setStatus(changeLanguage('status', 'selectlanguage')) 
        }
       

    }

    const onClearChat = () => {
        setPromptsAndResponses([])
        setPrompt('')
        setChatName('')
        setStatus('')
    }

    const deleteChat = async (deletionChat) => {

        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newchatNames = [];

        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/translations/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
            console.log("Translation chat names:", newchatNames)
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        console.log("Adjusted Translation Chats:", adjustedChats)

        var templates = JSON.stringify(adjustedChats)
        
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/translations/save", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setIsLoading(false)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return
        }
        
        setChatNames(adjustedChats);

        setIsLoading(false)
    }

    const displayChat = (displayedChat) => {
        onClearChat();

        //fix prompts ids to match array indexes
        let index = 0;
        displayedChat.promptsandresponses.forEach((item) => {
                item.id = index;
                index++   
        })   
        
        setPromptsAndResponses(displayedChat.promptsandresponses)
        setChatName(displayedChat.chatname)
        setLanguage(displayedChat.translanguage)

        var deletes = []
        displayedChat.promptsandresponses.forEach((item) => {
             let a = {
                id: item.id,
                state: false
             }
             deletes.push(a)   
        })

        setConfirmDelete(deletes)

    }

    const onDeletePrompt = (deletionChat) => {
        if (isLoading)
            return;
        let index = promptsandresponses.indexOf(deletionChat)
        let filteredChats = promptsandresponses.filter(chat => chat.id !== deletionChat.id)
        setPromptsAndResponses(filteredChats)
        
        let deleteconfirm = [...confirmDelete]
        deleteconfirm.splice(index, 1)
        setConfirmDelete(deleteconfirm)

    }

    const changeConfirmDelete = (prompt, flag) => {
        let a = [...confirmDelete]
        a.forEach((item)=>{
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDelete(a)

    }


    const onSave = async () => {
        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return
        }
        if (promptsandresponses.length === 0)
        {
            setStatus(changeLanguage('status', 'noresponsetosave')) 
            return;
        }

        let exists = false;

        let newChats = [];
        let newChat = [];
        let newchatNames = [];

        setIsLoading(true);

        let chatstatus = await getChats('translations');
        if (chatstatus.status !== 200)
        {
            setStatus("Unable to retrieve topics data.")
            setIsLoading(false);
            return;
        }

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }

                    chat.promptsandresponses = promptsandresponses;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0;

            newchatNames === 0 ? i = 0 : i = newchatNames.length;
       
            newChat = {
                id: i,
                translanguage: language,
                chatname: chatName,
                promptsandresponses: promptsandresponses,
            };

            newChats.push(newChat);
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
        }

        let templates = JSON.stringify(newChats)

        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/translations/save", { currentUser, templates }, {
            withCredentials: true
            })
        }
        catch (err) {
            setIsLoading(false);
            setStatus(`Error: ${checkServerCode(err.code)}`)
            return
        }

        setChatNames(newChats)
        setIsLoading(false);

    }

    const onTranslate = () => {

       console.log("Language:", language)
        if (language.length === 0)
        {
            setStatus(changeLanguage('select', 'pleaseselectlanguage'))
            return;
        }
    

        //let s = `Translate the following text to ${language}: ${prompt}`
        let s = `Translate the following text to ${language}:`
        SendRequest(s, prompt)

    }

    async function SendRequest(task, request) {
        setStatus('')
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        if (prompt.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

        let i = 0;
        if (promptsandresponses.length) {
            i = promptsandresponses[promptsandresponses.length - 1].id + 1
        }

        let r = {
            id: i,
            prompt: request,
            response: "",
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setPromptsAndResponses([...promptsandresponses, r])
        ScrollResponse()
        if (promptsandresponses.length > 0)
            {
                setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
                handleFocus()
            }

        if (confirmDelete.length <= promptsandresponses.length) {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a])
        }
        let rqst = task + request

        let req = {
            request: rqst,
            temperature: 1,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

        setIsLoading(true)

        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", {req},{
                    withCredentials:true
                })
            

            let server_response = JSON.parse(res.data);

            if (promptsandresponses.length) {
                i = promptsandresponses[promptsandresponses.length - 1].id + 1
            } else i = 0
            r = {
                id: i,
                prompt: request,
                response: server_response.data,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }            
            setPromptsAndResponses([...promptsandresponses, r])
            ScrollResponse()
            setWaitOnResponse('')
            handleFocus()
            updateCredits(server_response.tokens)

    
        } catch(err)
        {
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
            setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
        }
        setIsLoading(false)
    }

    return <TranslationContext.Provider value={{
        language,
        setLanguage,
        prompt,
        setPrompt,
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onTranslate,
        onClearChat,
        deleteChat,
        displayChat,
        promptsandresponses,
        onSave,
   
        displaySample,
        onDeletePrompt, 
        changeConfirmDelete,
        confirmDelete,
        status,

        showTranslationLanguages,
        setShowTranslationLanguages
      
    }}>
        {props.children}
    </TranslationContext.Provider>
})